<template>
  <Button
    @click.prevent="handleClick"
    size="sm"
    :border="false"
    theme="CART"
    class="absolute right-3 rounded-lg !px-[1rem] !pt-[0.5rem] cursor-pointer z-20"
    :aria-label="`${productName} add to cart opens simulated dialog`"
    :title="`${productName} add to cart opens simulated dialog`"
    type="button"
    :id="`add-to-cart-${id}`"
  >
    <Icon icon="cart-plus" :id="`icon-cart-${id}`" />
  </Button>
</template>

<script setup lang="ts">
import Button from '../../atom/button.vue'
import Icon from '../../atom/icon.vue'
import { useCartModalStore } from '~/stores/cartModalStore'
import siteService from '~/composables/siteService'
import type { AddToCartAnalyticsContext } from '~~/shared/types/common'

const props = defineProps<{
  productId: number
  id: any
  productName: string
  analyticsContext?: AddToCartAnalyticsContext
}>()

const emit = defineEmits<{
  (e: 'added'): void
}>()

const cartModalStore = useCartModalStore()
const addToCart = async (productId: number | undefined) => {
  if (!productId) {
    cartModalStore.open()
    return
  }
  try {
    const response = await siteService().addToCart(productId, 1, 0, false, props.analyticsContext ?? null) as any    
    const modalData = response.lines.find(line => line.productId === productId);
    const totalQuantity = response.lines.reduce((sum, line) => sum + line.quantity, 0);
    cartModalStore.open(
      {
        name: modalData.name,
        subtotal: modalData.subtotal,
        imageUrl: modalData.imageUrl,
        quantity: modalData.quantity,
        id: `add-to-cart-${props.id}`
      },
      totalQuantity
    )
  } catch (err) {
    console.error("Request failed with error: ", err)
    cartModalStore.open()
  }
}

const handleClick = () => {
  addToCart(props.productId)
  emit('added')
}
</script>
